<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        btitle="Multicast Config"
        style="height: 410px"
      >
      <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="isShowAddTable = true"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
               <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllMcast"
                />
                <label for="idSelectAllMcast"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in mcastTable"
              :key="row.profileid"
              :class="{ 'true:': true }"
              @click="changeSelect(row)"
            >
              <td width="40px">
                <div @click.stop="" v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectMcast' + index"
                  />
                  <label :for="'idRowSelectMcast' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.mcastPort }}</div>
              </td>
              <td>
                <div>{{ row.mcastMode }}</div>
              </td>
              <td>
                <div>{{ row.fastLeave }}</div>
              </td>
              <td>
                <div>{{ row.mcastGroup }}</div>
              </td>
              <td>
                <div>{{ row.mcastDsTag | DsTagFormat }}</div>
              </td>
              <td>
                <div>{{ row.mcastDsVlan }}</div>
              </td>
              <td>
                <div>{{ row.mcastDsPri }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box :btitle="'Mcast Edit'" @close="isShowAddTable = false" style="min-height: 410px">
            <form class="form-horizontal" role="form">

               <div class="form-group">
                <label class="col-sm-3 control-label" for="mcastport">{{
                  title.mcastPort
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(4)}">
                  <input
                    type="text"
                    class="form-control"
                    id="mcastport"
                    v-model="mcastForm.mcastPort"
                    placeholder="INTEGER<1-24>"
                  />
                   <small
                        class="help-block"
                        :style="{
                          display: input_para_check(4) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(4) }}
                      </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="mcastmode">{{
                  title.mcastMode
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mcastmode"
                    v-model="mcastForm.mcastMode"
                  >
                    <option value="" disabled selected style="display: none">
                      please choose..
                    </option>
                    <option value="1">igmp-snooping</option>
                    <option value="0">olt-control</option>
                    <option value="2">default</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="fastLeave">{{
                  title.fastLeave
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="fastLeave"
                    v-model="mcastForm.fastLeave"
                  >
                    <option value="" disabled selected style="display: none">
                      please choose..
                    </option>
                    <option value="0">disable</option>
                    <option value="1" selected>enable</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="mcastgroup">{{
                  title.mcastGroup
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                  <input
                    type="text"
                    class="form-control"
                    id="mcastgroup"
                    v-model="mcastForm.mcastGroup"
                    placeholder="INTEGER<1-128>"
                  />
                   <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                </div>
              </div>
              <!-- 
              <div class="form-group">
                <label class="col-sm-3 control-label" for="mcastUsTag">{{
                  title.mcastUsTag
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mcastUsTag"
                    v-model="mcastForm.mcastUsTag"
                  >
                    <option value="">
                      None
                    </option>
                    <option value="1">add</option>
                    <option value="2">translate</option>
                  </select>
                </div>
              </div>

              <div v-if="mcastForm.mcastUsTag > '0'" class="form-group">
                <label class="col-sm-3 control-label" for="mcastUsVlan">{{
                  title.mcastUsVlan
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                  <input
                    type="text"
                    class="form-control"
                    id="mcastUsVlan"
                    v-model="mcastForm.mcastUsVlan"
                    placeholder="Vlan(1-4094)"
                  />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                </div>
              </div>

              <div
                v-if="
                  mcastForm.mcastUsTag == '1' || mcastForm.mcastUsTag == '2'
                "
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="mcastUsPri">{{
                  title.mcastUsPri
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mcastUsPri"
                    v-model="mcastForm.mcastUsPri"
                  >
                    <option value="" >
                      None
                    </option>
                    <option value="0">0</option>
                    <option v-for="i in 7" :key="i" :value="i">{{ i }}</option>
                  </select>
                </div>
              </div> 
              -->
               
              <div class="form-group">
                <label class="col-sm-3 control-label" for="mcastDsTag">{{
                  title.mcastDsTag
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mcastDsTag"
                    v-model="mcastForm.mcastDsTag"
                  >
                    <option value="" disabled selected style="display: none">
                      please choose..
                    </option>
                    <option value="0">transparent</option>
                    <option value="1">remove</option>
                    <option value="2">add</option>
                    <option value="3">translate</option>
                  </select>
                </div>
              </div>

              <div v-if="mcastForm.mcastDsTag > '1'" class="form-group">
                <label class="col-sm-3 control-label" for="mcastDsVlan">{{
                  title.mcastDsVlan
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                  <input
                    type="text"
                    class="form-control"
                    id="mcastDsVlan"
                    v-model="mcastForm.mcastDsVlan"
                    placeholder="INTEGER<1-4094>"
                  />
                  <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                </div>
              </div>

              <div
                v-if="
                  mcastForm.mcastDsTag == '2' || mcastForm.mcastDsTag == '3'
                "
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="mcastDsPri">{{
                  title.mcastDsPri
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mcastDsPri"
                    v-model="mcastForm.mcastDsPri"
                  >
                    <option value="">
                      None
                    </option>
                    <option value="0">0</option>
                    <option v-for="i in 7" :key="i" :value="i">{{ i }}</option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from '@/components/DialogBox'

export default {
  name: "profileLineMcast",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId"],

  data() {
    return {
      title: {
        mcastPort: "Ont Port",
        mcastMode: "Mcast Mode",
        fastLeave: "Fast Leave",
        mcastGroup: "Max Group",
        mcastUsTag: "UsTag",
        mcastUsVlan: "UsTag Vlan",
        mcastUsPri: "UsTag Pri",
        mcastDsTag: "DsTag",
        mcastDsVlan: "DsTag Vlan",
        mcastDsPri: "DsTag Pri",
      },

      isShowAddTable: false,
      iBox:{},
      isEditClik: false,
      mcastForm: {
        mcastPort: "",
        mcastMode: "2",
        fastLeave: "1",
        mcastGroup: "",
        mcastUsTag: "",
        mcastUsVlan: "",
        mcastUsPri: "",
        mcastDsTag: "0",
        mcastDsVlan: "",
        mcastDsPri: "",
      },

      mcastTable: [],
    }
  },

  created() {
    this.loadMcastInfo()
  },

  
  watch:{
    'mcastForm.mcastUsTag':function(newval, oldval){
        if(oldval != "")
        {
          this.mcastForm.mcastUsVlan = ""
          this.mcastForm.mcastUsPri = ""
        }
    },

    'mcastForm.mcastDsTag':function( newcal, oldval){
        if(oldval != "")
        this.mcastForm.mcastDsVlan = ""
        this.mcastForm.mcastDsPri = ""
    }
  },

  methods: {
    loadMcastInfo() {
      get("profilelinemcast?profileId=" + this.profileId)
        .then((res) => {
          this.title = res.data.title
          this.mcastTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    resetField() {
      var dbaformTmp = {
        mcastPort: "",
        mcastMode: "2",
        fastLeave: "1",
        mcastGroup: "",
        mcastUsTag: "",
        mcastUsVlan: "",
        mcastUsPri: "",
        mcastDsTag: "0",
        mcastDsVlan: "",
        mcastDsPri: "",
      }

      this.mcastForm = dbaformTmp
    },
    

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },


    clkDel(){  var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: Number(this.profileId),
        mcastMode: 2,
        fastLeave: 1,
        mcastGroup: 0,
        mcastUsTag: -1,
        mcastUsVlan: -1,
        mcastUsPri: -1,
        mcastDsTag:  0,
        mcastDsVlan: -1,
        mcastDsPri: -1,
      }

      for (i = 0; i < this.mcastTable.length; i++) {
        if (this.mcastTable[i].selected) {
          newProfile.mcastPort = Number(this.mcastTable[i].mcastPort)
          del.push(post("profilelinemcast", newProfile))
          id.push(this.mcastTable[i].mcastPort)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.mcastTable.length; i++) {
                if (this.mcastTable[i].mcastPort == id[index]) {
                  this.mcastTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", "Post error!")
        })
    },

    clkApply() {
       var newProfile = {
        profileId: Number(this.profileId),
        mcastPort: Number(this.mcastForm.mcastPort),
        mcastMode: Number(this.mcastForm.mcastMode),
        fastLeave: Number(this.mcastForm.fastLeave),
        mcastGroup: Number(this.mcastForm.mcastGroup),
        mcastUsTag: Number(this.mcastForm.mcastUsTag),
        mcastUsVlan: Number(this.mcastForm.mcastUsVlan),
        mcastUsPri:  Number(this.mcastForm.mcastUsPri),
        mcastDsTag:  Number(this.mcastForm.mcastDsTag),
        mcastDsVlan: Number(this.mcastForm.mcastDsVlan),
        mcastDsPri:  Number(this.mcastForm.mcastDsPri),
      }
      var i;
      var tmpProfile;

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )

          return
      }

      for( i in this.mcastForm){
        if(this.mcastForm[i] == "")
          newProfile[i] = -1
      }

      for(i= 0; i < this.mcastTable.length; i++)
      {
        if(this.mcastTable[i].mcastPort == this.mcastForm.mcastPort)
        {
              this.showAlertBox(
              "warn",
              "Message",
              "this port has been configured, please choose an other port "
              )

              return 
        }

        if(this.mcastTable[i].mcastPort == "all")
        {
              this.showAlertBox(
              "warn",
              "Message",
              "config of hgu ont has been existed, please del config first "
              )

              return 
        }
      
      }

      post("profilelinemcast", newProfile)
          .then((res) => {
            if (res.data == undefined || res.data.code === undefined || res.data.code === 0)
            {
              this.showAlertBox("info", "Info", "config successful!")
              this.loadMcastInfo()
              /*let index = newProfile.mcastPort - 1
              tmpProfile = this.mcastTable[index]
              for( i in newProfile){
                  if(newProfile[i] != -1)
                    tmpProfile[i] = newProfile[i]
              }*/
            }
            else this.showAlertBox("warn", "Message", res.data.msg)
          })
          .catch((err) => {
            console.log(err)
            this.showAlertBox("critical", "error", err)
          })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit(row) {
      this.mcastForm.mcastPort = row.mcastPort
      if(row.mcastMode == 'default')
        this.mcastForm.mcastMode = '2'
      else if(row.mcastMode == 'olt-control')
        this.mcastForm.mcastMode = '0'
      else if(row.mcastMode == 'igmp-snooping')
        this.mcastForm.mcastMode = '1'

      if(row.fastLeave == 'enable')
        this.mcastForm.fastLeave= '1'
      else if(row.fastLeave == 'disable')
        this.mcastForm.fastLeave= '0'

      if(row.mcastGroup != '0')
      {
        this.mcastForm.mcastGroup = row.mcastGroup
      }

      if(row.mcastUsTag == 'add')
        this.mcastForm.mcastUsTag= '1'
      else if(row.mcastUsTag == 'transparent')
        this.mcastForm.mcastUsTag= '0'
      else if(row.mcastUsTag == 'translate')
        this.mcastForm.mcastUsTag = '2'
      this.mcastForm.mcastUsVlan = row.mcastUsVlan
      this.mcastForm.mcastUsPri = row.mcastUsPri
      
      if(row.mcastDsTag == 'add')
        this.mcastForm.mcastDsTag= '2'
      else if(row.mcastDsTag == 'transparent')
        this.mcastForm.mcastDsTag= '0'
      else if(row.mcastDsTag == 'translate')
        this.mcastForm.mcastDsTag= '3'
      else if(row.mcastDsTag == 'remove')
        this.mcastForm.mcastDsTag= '1'
      this.mcastForm.mcastDsVlan = row.mcastDsVlan
      this.mcastForm.mcastDsPri = row.mcastDsPri

      this.isShowAddTable = true
      this.isEditClik = true
    },

    clickReflash(){
      this.loadMcastInfo()
    },

        /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    changeSelectAll() {
      for (let i = 0; i < this.mcastTable.length; i++) {
       if (this.isSelectAll) {
          this.$set(this.mcastTable[i], "selected", true)
        } else {
          this.$set(this.mcastTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.mcastForm.mcastGroup != "")
        {
            let mcastGroup = Number(this.mcastForm.mcastGroup)
            if(!isNaN(mcastGroup))
            {
                if(mcastGroup < 1 || mcastGroup > 128)
                return "max mcastGroup must be in range 1-128"
            }
            else
              return "max mcastGroup must be in range 1-128"
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.mcastForm.mcastUsVlan != "")
        {
            let mcastUsVlan = Number(this.mcastForm.mcastUsVlan)
            if(!isNaN(mcastUsVlan))
            {
                if(mcastUsVlan < 1 || mcastUsVlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }

      
      if(value == 3 || value == 0)
      {
        if(this.mcastForm.mcastDsVlan != "")
        {
            let mcastDsVlan = Number(this.mcastForm.mcastDsVlan)
            if(!isNaN(mcastDsVlan))
            {
                if(mcastDsVlan < 1 || mcastDsVlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }

       if(value == 4 || value == 0)
      {
        if(this.mcastForm.mcastPort != "")
        {
            let mcastGroup = Number(this.mcastForm.mcastPort)
            if(!isNaN(mcastGroup))
            {
                if(mcastGroup < 1 || mcastGroup > 24)
                return "ont port must be in range 1-24"
            }
            else
              return "ont port must be in range 1-24"
        }
      }

      return null
    }
  },

  filters: {
    capitalize: function (value) {
      if (value == "1") return "igmp-snooping"
      else if (value == "0") return "olt-control"
      else if (value == "2") return "default"
      else return value
    },

    EnableFormat: function (value) {
      if (value == "0") return "Disable"
      if (value == "1") return "Enable"
      return value
    },
 
    DsTagFormat: function (value) {
      if (value == "0") return "transparent"
      if (value == "1") return "remove"
      if (value == "2") return "add"
      if (value == "3") return "translate"
      if (value == "4") return "translate"
      if (value == "5") return "add"

      return value
    },

    UsTagFormat: function (value) {
      if (value == "0") return "transparent"
      if (value == "1") return "add"
      if (value == "2") return "translate"
      if (value == "3") return "translate"
      if (value == "4") return "add"

      return value
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>
